import React from 'react';
import { ButtonTertiary, createBasicColorSet, IconArrowRight, KeyboardDetectionProvider, cssSpacing, creatorLightTheme, screenXsMax, } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { DELAYS, fadeInAnimation, Grid, withAnimationContext, TWO_COLUMN_MAX_WIDTH, VideoEmbed, SectionHeader, VideoPlayer, } from '../../ui';
import { youtubeIdRegex } from '../../ui/utils';
import { ColorSetWrapper } from '../../ui/Colors/Colors';
import { useFrodorModules } from '../../Context/FrodorModulesProvider';
const { invertedDark } = creatorLightTheme;
const Container = styled(Grid) `
  // add extra top padding for nav when header
  padding-top: ${({ isHeader }) => isHeader
    ? `calc(${cssSpacing('looser-3')} + ${cssSpacing('looser-4')})`
    : cssSpacing('looser-3')};
  padding-bottom: ${cssSpacing('looser-3')};
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    // add extra top padding for nav when header
    padding-top: ${({ isHeader }) => isHeader
    ? `calc(${cssSpacing('looser-2')} + ${cssSpacing('looser-4')})`
    : cssSpacing('looser-2')};
  }
  @media (max-width: ${screenXsMax}) {
    padding-bottom: ${cssSpacing('looser-5')};
  }

  .content {
    grid-column: ${({ videoLayout }) => videoLayout === 'right' ? '1 / 5' : '9 / -1'};
    order: ${({ videoLayout }) => (videoLayout === 'right' ? 1 : 2)};
    padding-right: ${cssSpacing('looser-3')};
    padding-right: ${({ videoLayout }) => videoLayout === 'right' ? cssSpacing('looser-3') : 0};
    padding-left: ${({ videoLayout }) => videoLayout === 'right' ? 0 : cssSpacing('looser-3')};
    @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
      order: 2;
      grid-column: 1 / -1;
      padding-right: 0;
      padding-left: 0;
      margin-top: ${cssSpacing('looser-2')};
    }
  }
  .video {
    grid-column: ${({ videoLayout }) => videoLayout === 'right' ? '5 / -1' : '1 / 9'};
    order: ${({ videoLayout }) => (videoLayout === 'right' ? 2 : 1)};
    @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
      order: 1;
      grid-column: 1 / -1;
    }
  }
`;
const Content = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;
const VideoContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const CtaContainer = withAnimationContext(styled.div `
    ${fadeInAnimation(DELAYS.FOURTH)};
    margin-top: ${cssSpacing('looser-2')};
  `);
export const VideoModule = React.forwardRef(({ supertext = '', headline = '', subtext = '', ctaLink = '', ctaText = '', videoUrl = '', videoControlColors, moduleColors = {
    textColor: invertedDark.text.base,
    backgroundColor: invertedDark.background.base,
}, useNativeVideo = false, muxVideo = null, videoLayout = 'right', isHeader = false, }, ref) => {
    const videoControlColorSet = (videoControlColors === null || videoControlColors === void 0 ? void 0 : videoControlColors.backgroundColor)
        ? createBasicColorSet(videoControlColors === null || videoControlColors === void 0 ? void 0 : videoControlColors.backgroundColor, videoControlColors === null || videoControlColors === void 0 ? void 0 : videoControlColors.textColor)
        : createBasicColorSet('#FFFFFF', '#000000');
    const { InteractiveElement } = useFrodorModules();
    return (React.createElement(KeyboardDetectionProvider, null,
        React.createElement(ColorSetWrapper, { colors: moduleColors },
            React.createElement(Container, { videoLayout: videoLayout, isHeader: isHeader },
                React.createElement(Content, { ref: ref, className: "content" },
                    React.createElement(SectionHeader, { eyebrow: supertext, heading: headline, body: subtext, cta: ctaLink &&
                            ctaText && (React.createElement(CtaContainer, null,
                            React.createElement(InteractiveElement, { href: ctaLink, customComponent: ButtonTertiary, buttonSize: "sm", iconTrailing: () => React.createElement(IconArrowRight, { iconSize: 16 }), trackingCategory: "module-video", trackingLabel: `CTA Link - ${ctaText}`, semanticColor: "textBase", condensed: true }, ctaText))) })),
                React.createElement(VideoContainer, { className: "video" }, useNativeVideo && muxVideo ? (React.createElement(VideoPlayer, { ...muxVideo, videoControlColors: videoControlColors })) : (React.createElement(React.Fragment, null, videoUrl.match(youtubeIdRegex) && (React.createElement(VideoEmbed, { url: videoUrl, colorSet: videoControlColorSet })))))))));
});
